// src/CacheManager.js

class CacheManager {
    constructor() {
        this.clientesCache = [];
        this.clientesById = {};
        this.clientesCacheDate = null;

        this.itensCache = [];
        this.itensById = {};
        this.itensCacheDate = null;

        this.agendamentosCache = [];
        this.agendamentosById = {};
        this.agendamentosCacheDate = null;

        this.faturasCache = [];
        this.faturasById = {};
        this.faturasCacheDate = null;

        this.pagamentosCache = [];
        this.pagamentosById = {};
        this.pagamentosCacheDate = null;

        this.espacosCache = [];
        this.espacosById = {};
        this.espacosCacheDate = null;
    }

    async loadData(url, nome, id_nome) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            this[`${nome}Cache`] = data || [];
            this[`${nome}CacheDate`] = new Date();

            this[`${nome}ById`] = {};
            this[`${nome}Cache`].forEach(item => {
                this[`${nome}ById`][item[id_nome]] = item;
            });
        } catch (error) {
            console.error(`Erro ao buscar dados de ${nome}:`, error);
        }
    }

    async getDataCache(nome) {
        if (!this[`${nome}CacheDate`] || (new Date() - this[`${nome}CacheDate`]) > 5 * 60 * 1000) {
            const loadMethod = `load${nome.charAt(0).toUpperCase() + nome.slice(1)}`;
            await this[loadMethod]();
        }
        return this[`${nome}Cache`];
    }

    async getDataById(nome) {
        if (!this[`${nome}CacheDate`] || (new Date() - this[`${nome}CacheDate`]) > 5 * 60 * 1000) {
            const loadMethod = `load${nome.charAt(0).toUpperCase() + nome.slice(1)}`;
            await this[loadMethod]();
        }
        return this[`${nome}ById`];
    }

    async loadClientes() {
        await this.loadData('https://api.faeworks.com.br/cliente/read.php', 'clientes', 'id_cliente');
    }

    async loadItens() {
        await this.loadData('https://api.faeworks.com.br/item/read.php', 'itens', 'id_item');
    }

    async loadAgendamentos() {
        await this.loadData('https://api.faeworks.com.br/agendamento/read.php', 'agendamentos', 'id_agendamento');
    }

    async loadFaturas() {
        await this.loadData('https://api.faeworks.com.br/fatura/read.php', 'faturas', 'id_fatura');
    }

    async loadPagamentos() {
        await this.loadData('https://api.faeworks.com.br/pagamento/read.php', 'pagamentos', 'id_pagamento');
    }

    async loadEspacos() {
        await this.loadData('https://api.faeworks.com.br/espaco/read.php', 'espacos', 'id_espaco');
    }

    invalidateClientesCache() {
        this.clientesCache = [];
        this.clientesCacheDate = null;
        this.clientesById = {};
    }

    invalidateItensCache() {
        this.itensCache = [];
        this.itensCacheDate = null;
        this.itensById = {};
    }

    invalidateAgendamentosCache() {
        this.agendamentosCache = [];
        this.agendamentosCacheDate = null;
        this.agendamentosById = {};
    }

    invalidateFaturasCache() {
        this.faturasCache = [];
        this.faturasCacheDate = null;
        this.faturasById = {};
    }

    invalidatePagamentosCache() {
        this.pagamentosCache = [];
        this.pagamentosCacheDate = null;
        this.pagamentosById = {};
    }

    invalidateEspacosCache() {
        this.espacosCache = [];
        this.espacosCacheDate = null;
        this.espacosById = {};
    }

    invalidateAllCache() {
        this.invalidateClientesCache();
        this.invalidateItensCache();
        this.invalidateAgendamentosCache();
        this.invalidateFaturasCache();
        this.invalidatePagamentosCache();
        this.invalidateEspacosCache();
    }

    async getClientesCache() {
        return this.getDataCache('clientes');
    }

    async getItensCache() {
        return this.getDataCache('itens');
    }

    async getAgendamentosCache() {
        return this.getDataCache('agendamentos');
    }

    async getFaturasCache() {
        return this.getDataCache('faturas');
    }

    async getPagamentosCache() {
        return this.getDataCache('pagamentos');
    }

    async getEspacosCache() {
        return this.getDataCache('espacos');
    }

    async getClientesById() {
        return this.getDataById('clientes');
    }

    async getItensById() {
        return this.getDataById('itens');
    }

    async getAgendamentosById() {
        return this.getDataById('agendamentos');
    }

    async getFaturasById() {
        return this.getDataById('faturas');
    }

    async getPagamentosById() {
        return this.getDataById('pagamentos');
    }

    async getEspacosById() {
        return this.getDataById('espacos');
    }
}

const cacheManager = new CacheManager();
export default cacheManager;